import React, { Component } from 'react';
import Form from '../../components/react-validation/components/form';
import Submit from '../../components/react-validation/components/submit';
import Input from '../../components/react-validation/components/input';
import {Modal} from 'react-bootstrap';
import * as Vali from '../../helper/validator-helper';
import PropTypes from 'prop-types';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import * as RequestTypeActionType from '../constants';
import Radio from 'components/CustomRadio/CustomRadio';
import Translate from 'components/translate';
import ConfirmModal from 'components/ConfirmModal';
import * as RequestTypePolicyActionType from '../constants';
import { connect } from 'react-redux';

export class AddEditRequestType extends Component {

  static propTypes = {
    fromHomeOwner: PropTypes.bool,
    isCreate: PropTypes.bool,
    show: PropTypes.bool,
    onCloseModal: PropTypes.func,
    isOpenFormAddEdit: PropTypes.bool,
    dispatch: PropTypes.func,
    onSubmit: PropTypes.func,
    requestTypeId: PropTypes.object,
    RequestTypeStore: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      radio: '0',
      disableCheckBox: false,
      checkedOption: {
        buyerOrientation: false,
        homeOwner: false
      },
      isShowForm: true,
      isShowConfirmModal: false
    };

    this.state.title = this.props.requestTypeId ? 'Edit ' : 'New request type';
  }

  componentDidMount() {
    if (this.props.requestTypeId) {
      this.props.dispatch({
        type: RequestTypePolicyActionType.GET_REQUEST_TYPE_BY_ID_ASYNC,
        params: this.props.requestTypeId
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.RequestTypeStore === this.props.RequestTypeStore) {
      return;
    }

    // if (this.form && nextProps.errorMsg.length) {
    //   this.form.showError(this.refs['name'], nextProps.errorMsg[0].error);
    // }

    this.setState({
      name: nextProps.RequestTypeStore.name,
      isActive: nextProps.RequestTypeStore.isActive,
      title: this.props.requestTypeId ? 'Edit ' + nextProps.RequestTypeStore.name : 'New request type' });

    if (nextProps.RequestTypeStore.type === 1) {
      this.setState({ radio: '1', disableCheckBox: true });
    }
    else {
      this.setState({
        radio: '0',
        disableCheckBox: false,
        checkedOption: {
          homeOwner: nextProps.RequestTypeStore.type === 2,
          buyerOrientation: nextProps.RequestTypeStore.type === 3
        }
      });
    }
  }

  componentWillUnmount() {
    console.log('unmounted');
  }

  optionType() {
    const { checkedOption } = this.state;

    if (this.state.radio === '1') {
      return 1;
    }
    else if (checkedOption.homeOwner === true) {
      return 2;
    }
    else if (checkedOption.buyerOrientation === true) {
      return 3;
    }

    return 0;
  }

  getParams() {
    let param = this.form.getValues();

    param['type'] = this.optionType();
    param['id'] = this.props.requestTypeId;
    param['isActive'] = this.state.isActive;

    return param;
  }

  onSubmit(e) {
    e.preventDefault();

    let convertedType = this.props.RequestTypeStore.type !== 1 ? '0' : '1';

    if (!this.props.requestTypeId) {
      this.props.onSubmit(
        this.getParams(),
        RequestTypeActionType.CREATE_REQUEST_TYPE_ASYNC,
        () => { this.props.onCloseModal(); });
    }
    else if (convertedType === this.state.radio) {
      this.props.onSubmit(this.getParams(), RequestTypeActionType.UPDATE_REQUEST_TYPE_ASYNC, () => {
        this.setState({isShowForm: true, isShowConfirmModal: false});
        this.props.onCloseModal();
      });
    }
    else {
      this.props.dispatch({
        type: RequestTypeActionType.CHECK_BEFORE_UPDATE_REQUEST_TYPE_ASYNC,
        data: { requestTypeId: this.props.requestTypeId },
        callback: (response) => {
          if (response) {
            this.setState({isShowForm: false, isShowConfirmModal: true, params: this.getParams()});
          }
          else {
            this.props.onSubmit(this.getParams(), RequestTypeActionType.UPDATE_REQUEST_TYPE_ASYNC, () => {
              this.setState({isShowForm: true, isShowConfirmModal: false});
              this.props.onCloseModal();
            });
          }
        }
      });
    }
  }

  onSave = () => {
    this.props.onSubmit(this.state.params, RequestTypeActionType.UPDATE_REQUEST_TYPE_ASYNC, () => {
      this.setState({isShowForm: true, isShowConfirmModal: false});
      this.props.onCloseModal(); });
  }

  onSelectRadio = event => {
    const target = event.target;
    const isWarrantyRadio = target.id === 'radio_warranty';

    this.setState({
      [target.name]: target.value,
      disableCheckBox: !isWarrantyRadio,
      checkedOption: {
        buyerOrientation: false,
        homeOwner: false
      }
    });
  };

  onCheckOption = (e, data, state) => {
    const { name, checked } = state;

    this.setState({ checkedOption: { [name]: checked } });
  }

  onChangeName = (e) => {
    this.setState({name: e.target.value});
  }

  renderRequestTypeForm() {
    let { name } = this.state;

    if (this.form && this.form.getValues().name) {
      name = this.form.getValues().name;
    }

    return (
      <React.Fragment>
        <div className='modal-header'>
          <button type='button' className='close' onClick={this.props.onCloseModal}>&times;</button>
          <h4 className='modal-title'>{this.state.title}</h4>
        </div>
        <Form ref={ref => { this.form = ref; }} onSubmit={this.onSubmit.bind(this)}>
          <div className='modal-body'>
            <div className='form-group'>
              <label>Request type <span className='text-danger'>*</span></label>
              <Input type='text'
                autoFocus
                name='name'
                ref='name'
                value={name}
                placeholder='Request type'
                className='form-control'
                max='100'
                maxLength='100'
                validations={[Vali.required, Vali.maxlength]} />
            </div>
            <div className='container'>
              <div className='row'>
                <Radio
                  number='radio_warranty'
                  option='0'
                  name='radio'
                  className='site-one-radio'
                  onChange={this.onSelectRadio}
                  checked={this.state.radio === '0'}
                  label='Warranty request'
                />
              </div>
              <div className='row'>
                <div style={{bottom: 5}} className='col-xs-3 col-md-3 col-lg-3'>
                  <CheckBoxSingle
                    disabled={this.state.disableCheckBox}
                    ref={c => { this.buyerOrientation = c; }}
                    name='buyerOrientation'
                    checked={this.state.checkedOption.buyerOrientation}
                    label='Electronic Signature Form'
                    className='checkbox-default'
                    onChecked={this.onCheckOption} />
                </div>
                <div style={{bottom: 5}} className='col-xs-3 col-md-3 col-lg-3'>
                  <CheckBoxSingle
                    disabled={this.state.disableCheckBox}
                    ref={c => { this.homeOwner = c; }}
                    name='homeOwner'
                    checked={this.state.checkedOption.homeOwner}
                    label={<Translate translateKey='homeowner' capitalize/>}
                    className='checkbox-default'
                    onChecked={this.onCheckOption} />
                </div>
              </div>
              <div className='row'>
                <Radio
                  number='radio_punchlist'
                  option='1'
                  name='radio'
                  className='site-one-radio'
                  onChange={this.onSelectRadio}
                  checked={this.state.radio === '1'}
                  label={<Translate translateKey='punchlist' capitalize />}
                />
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <Submit className='btn btn-primary btn-siteone'>Done</Submit>
          </div>
        </Form>
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Modal show={this.state.isShowForm}>
          {this.renderRequestTypeForm()}
        </Modal>
        <ConfirmModal
          title='Confirmation'
          message='This request type is already associated with at least one EPL template. It will be removed from the EPL template if you proceed to update. Continue? '
          okText='Save and remove from EPL template'
          cancelFunc={() => this.setState({isShowForm: true, isShowConfirmModal: false})}
          okFunc={() => { this.onSave(); }}
          show={this.state.isShowConfirmModal}/>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    RequestTypeStore: state.RequestTypeStore.RequestTypeProfile
  };
};

export default connect(mapStateToProps)(AddEditRequestType);



// WEBPACK FOOTER //
// ./src/Request-Types/Components/add-edit-request-type.js